import { VariantType, enqueueSnackbar } from "notistack";

export const unwrappableActionSnackbarNotificationDecorator = <TReason>(
    unwrappableAction: { unwrap: () => Promise<unknown> },
    succesMessage?: string,
    errorMessage?: string | ((reason: TReason) => string),
    showThunkAbortErrors?: boolean,
    successMessageVariant?: VariantType,
) => {
    unwrappableAction
        .unwrap()
        .then(
            () =>
                succesMessage &&
                enqueueSnackbar(succesMessage, {
                    variant: successMessageVariant || "success",
                }),
        )
        .catch((reason: TReason | ThunkAbortError) => {
            if (!errorMessage) return;

            let msg: string;

            if (isThunkAbortError(reason)) {
                if (!showThunkAbortErrors) return;

                msg = reason.message;
            } else {
                msg =
                    errorMessage instanceof Function
                        ? errorMessage(reason)
                        : errorMessage;
            }

            enqueueSnackbar(msg, {
                variant: "error",
            });
        });
};

interface ThunkAbortError {
    name: "AbortError";
    message: "Aborted";
}

const isThunkAbortError = (
    arg: ThunkAbortError | unknown,
): arg is ThunkAbortError => {
    const casted = arg as ThunkAbortError;
    return casted.name === "AbortError" && casted.message === "Aborted";
};
